import React from 'react';
import { GlobeIcon, CheckCircleIcon, UserPlusIcon } from 'lucide-react';
export const OpportunitySection = () => {
  return <section className="py-32 md:py-40 bg-white relative" data-id="element-135">
      <div className="container mx-auto px-6 md:px-12 max-w-6xl" data-id="element-136">
        <div className="grid md:grid-cols-[1fr_1.5fr] gap-16 md:gap-20 items-start" data-id="element-137">
          {/* Left column - heading and intro */}
          <div className="max-w-md" data-id="element-138">
            <h2 className="text-4xl md:text-5xl font-semibold mb-6 tracking-tight text-[#111928]" data-id="element-139">
              The Opportunity
            </h2>
          </div>

          {/* Right column - vertical list with accent bars */}
          <div className="space-y-8 pt-2" data-id="element-140">
            <div className="group flex gap-6 items-start" data-id="element-141">
              <div className="w-1 h-16 bg-[#186447] transition-all group-hover:h-20 group-hover:bg-[#22AC79]" data-id="element-142"></div>
              <div className="flex-1" data-id="element-143">
                <div className="flex items-center gap-3 mb-2" data-id="element-144">
                  <GlobeIcon className="w-5 h-5 text-[#186447]" strokeWidth={1.5} data-id="element-145" />
                </div>
                <p className="text-base text-[#6B7280] leading-relaxed" data-id="element-146">
                  Become a glow-up coach for clients beyond your local area and
                  across your online audience.
                </p>
              </div>
            </div>

            <div className="group flex gap-6 items-start" data-id="element-147">
              <div className="w-1 h-16 bg-[#186447] transition-all group-hover:h-20 group-hover:bg-[#22AC79]" data-id="element-148"></div>
              <div className="flex-1" data-id="element-149">
                <div className="flex items-center gap-3 mb-2" data-id="element-150">
                  <CheckCircleIcon className="w-5 h-5 text-[#186447]" strokeWidth={1.5} data-id="element-151" />
                </div>
                <p className="text-base text-[#6B7280] leading-relaxed" data-id="element-152">
                  Provide personalized aesthetic coaching in a format that's
                  easy to maintain through an app.
                </p>
              </div>
            </div>

            <div className="group flex gap-6 items-start" data-id="element-153">
              <div className="w-1 h-16 bg-[#186447] transition-all group-hover:h-20 group-hover:bg-[#22AC79]" data-id="element-154"></div>
              <div className="flex-1" data-id="element-155">
                <div className="flex items-center gap-3 mb-2" data-id="element-156">
                  <UserPlusIcon className="w-5 h-5 text-[#186447]" strokeWidth={1.5} data-id="element-157" />
                </div>
                <p className="text-base text-[#6B7280] leading-relaxed" data-id="element-158">
                  Build trust with new clients who may later become in-office
                  patients.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};